import React from 'react'
import ReactDOM from 'react-dom'
import App from './App'
import {DataAPI} from './Components/service'
import "@babel/polyfill";

var ajaxErrHandler=function(xhr, ajaxOptions, thrownError) {
    console.log(xhr.responseText)
}
var app = React.createElement(App, {
    dataApi: new DataAPI(ajaxErrHandler, false)
})
ReactDOM.render(app, document.getElementById("asnf"))
